import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/styled-system'
import { siteNavigationColorKeys } from '~/pages/Home/SiteNavigation/componentStyles/_colors'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

export enum SiteNavigationSizes {
  Normal = 'normal',
  Collapsed = 'collapsed',
  Small = 'small',
}

const { Background } = siteNavigationColorKeys.SiteNavigation
const SiteNavigationParts = [
  'container',
  'tabWrapper',
  'footerWrapper',
] as const

const helpers = createMultiStyleConfigHelpers(SiteNavigationParts)

export const SiteNavigationStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: '11.75rem',
      alignSelf: 'stretch',
      paddingBottom: '0.5rem',
      alignItems: 'flex-start',
      borderRight: '2px solid',
      borderRightColor: 'gray.400',
      justifyContent: 'space-between',
      bg: Background,
      transition: 'width 0.2s linear',
      zIndex: 4,
    },
    tabWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      alignSelf: 'stretch',
      gap: '0.25rem',
    },
    footerWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignSelf: 'stretch',
      gap: '0.25rem',
    },
  },
  sizes: {
    [SiteNavigationSizes.Normal]: {
      container: {
        width: '11.75rem',
        paddingX: '0.5rem',
        paddingTop: '0.5rem',
      },
    },
    [SiteNavigationSizes.Collapsed]: {
      container: {
        width: '4rem',
        alignItems: 'center',
        paddingTop: '0.5rem',
      },
      tabWrapper: {
        alignItems: 'center',
      },
    },
    [SiteNavigationSizes.Small]: {
      container: {
        width: '4rem',
        alignItems: 'center',
        paddingTop: '0',
      },
      tabWrapper: {
        alignItems: 'center',
      },
    },
  },
  defaultProps: {
    size: SiteNavigationSizes.Normal,
  },
})

export const useSiteNavigationStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof SiteNavigationParts>(
    getName({ SiteNavigationStyle }),
    props,
  )
}
